import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,_vm._g(_vm._b({on:{"click":function($event){_vm.loan.document ? _vm.downloadLoanDocument() : _vm.$emit('toggleDialog', _vm.loan)}}},'v-list-item',_vm.$attrs,false),_vm.$listeners),[_c(VListItemTitle,[_vm._v(" "+_vm._s(_vm.label || _vm.$t('dealer-bike.detail.actions.download-loan-doc'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }